import Vue from 'vue';
import VueResource from 'vue-resource'
Vue.use(VueResource);

export default {
    getRecords(params, success_callback, fail_callback) {
        let query = '?uid=' + params.uid + '&page=' + params.page + '&order_status=' + params.recordsStatus + '&start_date=' + params.startDate + '&end_date=' + params.endDate;
        let apiUrl = '';
        let records = params;
        if (params.recordsType == 'consume') {
            apiUrl = 'store/records' + query;
            records.recordsType = 'consume';
        } else {
            apiUrl = 'recharge/records' + query;
            records.recordsType = 'recharge';
        }

        Vue.http.get(apiUrl).then((response) => {
            let apiResult = response.data;
            let apiCode = parseInt(apiResult.code);
            if (apiCode === 0) {
                let recordsData = [];
                if (params.recordsType == 'consume') {
                    recordsData = apiResult.result.consumeOrderList;
                } else {
                    recordsData = apiResult.result.rechargeOrderList;
                }
                records.data = recordsData;
                success_callback(records);
            } else {
                fail_callback(apiCode);
            }
        }, () => {
            fail_callback(-1);
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/records.js